import { RequestFormValidatorErrors } from 'cpfr-common';
import { TFunction } from 'i18next';

export const RequestFormMessages = (t: TFunction): RequestFormValidatorErrors => {
    const translationPrefix = 'validation-error';
    const requiredFieldError = t(`${translationPrefix}.required-field`);
    const invalidYearError = t(`${translationPrefix}.invalid-year`);
    const categoryRequiredError = t(`${translationPrefix}.category-missing`);
    const emailInvalidError = t(`${translationPrefix}.e-mail-invalid`);
    const phoneNumberError = t(`${translationPrefix}.phonenumber-invalid`);
    const dateError = t(`${translationPrefix}.data-selector-missing`);
    const filesMax3NumberError = t(`${translationPrefix}.document-upload-to-many-files-max-3`);
    const fileSizeExceededError = t(`${translationPrefix}.document-upload-filesize-exceeded`);
    const shortInputRequiredError = t(`${translationPrefix}.short-input-missing`);
    const shortInputMaxLengthError = t(`${translationPrefix}.short-input-too-long`);
    const postCodeLengthError = t(`${translationPrefix}.postcode-invalid`);

    return {
        email: {
            required: requiredFieldError,
            mustBeEmail: emailInvalidError,
        },
        contractsSelection: {
            required: requiredFieldError,
        },
        categorySelection: {
            required: categoryRequiredError,
        },
        contractsNumbers: {
            required: requiredFieldError,
        },
        requestDocumentsErrorMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phoneNumber: {
                mustBePhoneNumber: phoneNumberError,
            },
            documentType: {
                required: requiredFieldError,
            },
            invoiceMonth: {
                required: requiredFieldError,
            },
            invoiceYear: {
                required: requiredFieldError,
            },
            desiredYear: {
                required: requiredFieldError,
                invalidYear: invalidYearError,
            },
            desiredTaxStatus: {
                required: requiredFieldError,
            },
            periodStartDate: {
                required: requiredFieldError,
            },
            periodEndDate: {
                required: requiredFieldError,
            },
            exitDate: {
                required: requiredFieldError,
            },
            returnDate: {
                required: requiredFieldError,
            },
            countryOfDestination: {
                required: requiredFieldError,
            },
            reason: {
                required: requiredFieldError,
            },
        },
        requestDeadlineErrorMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            deadline: {
                required: requiredFieldError,
                min: requiredFieldError,
            },
            phoneNumber: {
                mustBePhoneNumber: phoneNumberError,
            },
        },
        requestLossErrorMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            natureOfClaim: {
                required: requiredFieldError,
            },
            startDate: {
                required: dateError,
            },
            phoneNumber: {
                mustBePhoneNumber: phoneNumberError,
            },
        },
        requestAuthorizationDebitMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phoneNumber: {
                mustBePhoneNumber: phoneNumberError,
            },
            nameSurname: {
                required: requiredFieldError,
            },
            authorizes: {
                required: requiredFieldError,
            },
            amount: {
                required: requiredFieldError,
            },
            balanceReason: {
                required: requiredFieldError,
            },
            files: {
                required: requiredFieldError,
                maxLength: filesMax3NumberError,
                maxFileSize: fileSizeExceededError,
            },
        },
        requestTenantChangeRequestErrorMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phonenumber: {
                mustBePhoneNumber: phoneNumberError,
            },
            transferDate: {
                required: requiredFieldError,
            },
            reason: {
                required: requiredFieldError,
            },
            transferTo: {
                required: requiredFieldError,
            },
            files: {
                dialogueSheet: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                idCopy: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                taxPackage: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                kbisOrInsee: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                newTenantIban: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                vehicleId: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                idCopyManager: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                taxReturn: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
            },
        },
        requestAuthorizationLeaveCountryMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phoneNumber: {
                mustBePhoneNumber: phoneNumberError,
            },
            exitDate: {
                required: dateError,
            },
            returnDate: {
                required: dateError,
            },
            reason: {
                required: requiredFieldError,
            },
            countryOfDestination: {
                required: requiredFieldError,
            },
        },
        requestOtherErrorMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phoneNumber: {
                required: phoneNumberError,
                mustBePhoneNumber: phoneNumberError,
            },
            subjectOfClaim: {
                required: shortInputRequiredError,
                maxLength: shortInputMaxLengthError,
            },
            message: {
                required: t(`${translationPrefix}.free-text-box-missing`),
                maxLength: t(`${translationPrefix}.free-text-box-too-long`),
            },
            files: {
                attachment: {
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
            },
        },
        requestRegistrationCertificateDuplicateErrorMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phoneNumber: {
                mustBePhoneNumber: phoneNumberError,
            },
            requestReason: {
                required: requiredFieldError,
            },
            files: {
                id: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                proofOfAddress: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                registrationCertificate: {
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                lossDeclaration: {
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                theftDeclaration: {
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
            },
        },
        requestFormDeathErrorMessages: {
            dateOfDeath: {
                required: requiredFieldError,
            },
            nameOfNotary: {
                maxLength: shortInputMaxLengthError,
            },
            addressOfNotary: {},
            phonenumberOfNotary: {
                mustBePhoneNumber: phoneNumberError,
            },
            emailOfNotary: {
                mustBeEmail: emailInvalidError,
            },
            civilityOfBeneficiary: {
                required: requiredFieldError,
            },
            firstNameOfBeneficiary: {
                required: shortInputRequiredError,
                maxLength: shortInputMaxLengthError,
            },
            nameOfBeneficiary: {
                required: shortInputRequiredError,
                maxLength: shortInputMaxLengthError,
            },
            addressOfBeneficiary: {
                required: requiredFieldError,
            },
            phonenumberOfBeneficiary: {
                required: phoneNumberError,
                mustBePhoneNumber: phoneNumberError,
            },
            emailOfBeneficiary: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            files: {
                deathCertificate: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                deedOfInheritance: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
            },
        },
        requestContractTransferMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phonenumber: {
                mustBePhoneNumber: phoneNumberError,
            },
            buyerNames: {
                required: requiredFieldError,
            },
            buyerPhonenumber: {
                required: phoneNumberError,
                mustBePhoneNumber: phoneNumberError,
            },
            buyerEmail: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            requestReason: {
                required: requiredFieldError,
            },
            requestReasonDescription: {
                required: requiredFieldError,
            },
            employmentStatus: {
                required: requiredFieldError,
            },
            files: {
                signedConfirmation: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                buyerIdentity: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                bankDetails: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                payslips: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                taxNotice: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                registrationDoc: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                proofOfAddress: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                buyerProofOfAddress: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                accomodationCertificate: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
                indentityDoc: {
                    required: requiredFieldError,
                    maxLength: filesMax3NumberError,
                    maxFileSize: fileSizeExceededError,
                },
            },
        },
        requestVehicleClaimErrorMessages: {
            reparable: {
                required: requiredFieldError,
            },
            nonReparableFields: {
                email: {
                    required: requiredFieldError,
                    mustBeEmail: emailInvalidError,
                },
                phoneNumber: {
                    required: phoneNumberError,
                    mustBePhoneNumber: phoneNumberError,
                },
                natureOfDamage: {
                    required: requiredFieldError,
                },
                dateOfDamage: {
                    required: dateError,
                },
                nameOfInsurer: {
                    required: requiredFieldError,
                },
                circumstancesOfTheDisaster: {
                    required: requiredFieldError,
                },
                causeOfSinistre: {
                    required: requiredFieldError,
                },
                addressOfInsurer: {
                    required: requiredFieldError,
                },
                postcodeOfInsurer: {
                    required: requiredFieldError,
                    minLength: postCodeLengthError,
                },
                cityOfInsurer: {
                    required: requiredFieldError,
                },
                insuranceCustomerNumber: {
                    required: requiredFieldError,
                },
                damageNumber: {
                    required: requiredFieldError,
                },
                phonenumberOfInsurer: {
                    required: phoneNumberError,
                    mustBePhoneNumber: phoneNumberError,
                },
                emailOfInsurer: {
                    required: requiredFieldError,
                    mustBeEmail: emailInvalidError,
                },
                expertReportAvailable: {
                    required: requiredFieldError,
                },
                originalRegDocument: {
                    required: requiredFieldError,
                },
                agreeToSend: {
                    required: requiredFieldError,
                },
                registrationFile: {
                    maxLength: filesMax3NumberError,
                    required: requiredFieldError,
                    maxFileSize: fileSizeExceededError,
                },
                files: {
                    flightReport: {
                        maxLength: filesMax3NumberError,
                        required: requiredFieldError,
                        maxFileSize: fileSizeExceededError,
                    },
                    invoice: {
                        maxLength: filesMax3NumberError,
                        required: requiredFieldError,
                        maxFileSize: fileSizeExceededError,
                    },
                    expertReport: {
                        maxLength: filesMax3NumberError,
                        required: requiredFieldError,
                        maxFileSize: fileSizeExceededError,
                    },
                    paymentDetails: {
                        maxLength: filesMax3NumberError,
                        required: requiredFieldError,
                        maxFileSize: fileSizeExceededError,
                    },
                    transferProposal: {
                        maxLength: filesMax3NumberError,
                        required: requiredFieldError,
                        maxFileSize: fileSizeExceededError,
                    },
                },
            },
        },
        requestChangeDurationMileageErrorMessages: {
            email: {
                required: requiredFieldError,
                mustBeEmail: emailInvalidError,
            },
            phoneNumber: {
                mustBePhoneNumber: phoneNumberError,
            },
            totalDuration: {
                required: requiredFieldError,
            },
            desiredMileage: {
                required: requiredFieldError,
            },
        },
    };
};
